import { render } from "./LegsSettingsView.vue?vue&type=template&id=274193f5"
import script from "./LegsSettingsView.vue?vue&type=script&lang=js"
export * from "./LegsSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__